var IdentifyStatus;
(function (IdentifyStatus) {
    IdentifyStatus["IDENTIFIED"] = "identified";
    IdentifyStatus["IDENTIFIED_WITH_CONDITION"] = "identified_with_condition";
    IdentifyStatus["FAILED"] = "failed";
})(IdentifyStatus || (IdentifyStatus = {}));
export default IdentifyStatus;
